import { Sparkles } from "lucide-react";

export const Header = () => (
  <header
    data-testid="site-header"
    className="fixed inset-x-0 top-0 z-50 border-b border-brand-muted bg-white/70 backdrop-blur-xl"
  >
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:h-20 md:px-12">
      <a href="#top" data-testid="header-logo-link" className="flex items-center gap-2">
        <Sparkles className="h-5 w-5 text-brand-accent" />
        <span className="font-display text-2xl font-semibold tracking-tight text-brand-ink">
          Teo&rsquo;s Nails
        </span>
      </a>
      <nav className="hidden items-center gap-10 text-sm font-medium text-brand-ink/70 md:flex">
        <a
          href="#services"
          data-testid="nav-services-link"
          className="transition-colors duration-300 hover:text-brand-accent"
        >
          Services
        </a>
        <a
          href="#gallery"
          data-testid="nav-gallery-link"
          className="transition-colors duration-300 hover:text-brand-accent"
        >
          Our work
        </a>
        <a
          href="#about"
          data-testid="nav-about-link"
          className="transition-colors duration-300 hover:text-brand-accent"
        >
          Why Teo&rsquo;s
        </a>
        <a
          href="#booking"
          data-testid="nav-contact-link"
          className="transition-colors duration-300 hover:text-brand-accent"
        >
          Contact
        </a>
      </nav>
      <a
        href="#booking"
        data-testid="header-booking-button"
        className="rounded-full bg-brand-accent px-5 py-2.5 text-sm font-medium text-white shadow-[0_8px_24px_rgba(190,24,93,0.25)] transition-transform duration-300 hover:-translate-y-0.5"
      >
        Book now
      </a>
    </div>
  </header>
);
